<template>
  <div>
    <router-view></router-view>
    <user-profile-modal
      :properties="app.modal.profile"
      v-if="app.modal.profile.visible"
    ></user-profile-modal>
    <user-change-password-modal
      :properties="app.modal.changePassword"
      v-if="app.modal.changePassword.visible"
    ></user-change-password-modal>
  </div>
</template>

<script>
import UserProfileModal from "@/modals/core/UserProfileModal";
import UserChangePasswordModal from "@/modals/core/UserChangePasswordModal";
import store from "@/store";
import core from "@/core";

export default {
  name: "App",
  components: {
    UserProfileModal,
    UserChangePasswordModal,
  },
  data() {
    return {
      app: store.state.app,
    };
  },
  mounted() {
    window.showModal = this.showModal;
    console.log("process : ", process);
    console.log("process.env.BASE_URL : ", process.env.BASE_URL);
  },
  methods: {
    showModal: function (params) {
      return core.alert.show(params);
    },
  },
};
</script>

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";
</style>
